
import { Action } from 'actions'
import { Observable } from 'rxjs'
import { filter } from 'rxjs/operators'
import { needDiscardData, DiscardTrigger } from 'helpers/discardTriggerHelpers'

export const toDiscardCache = <A extends Action> (triggers: DiscardTrigger[]) => (source: Observable<A>) => {
  return source.pipe(
    filter(needDiscardData(triggers))
  ) as Observable<Action>
}
